import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z","key":"svg-0"}]]

const IconFlare = createReactComponent('outline', 'flare', 'Flare', __iconNode);

export default IconFlare;